import CONSTANTS from 'constants/state';
import actions from '../actions/multi-currency';
import initData from 'init-data';
import cookieUtil from '../../utils/cookie';

const isMultiCurrencyEnabled = () => {
    const featureSwitches = initData.featureSwitches || {};
    return !!featureSwitches['multi-currency'];
};

const resolveCurrency = currencyCodeOrNull => {
    if (!isMultiCurrencyEnabled() || !currencyCodeOrNull) {
        return null;
    }
    const result = (initData.currencies || []).find(
        currency => currency.code === currencyCodeOrNull
    );
    if (result) {
        return result;
    }
    return null;
};

const resolveCode = currencyCodeOrNull => {
    if (!isMultiCurrencyEnabled() || !currencyCodeOrNull) {
        return null;
    }
    const currency = resolveCurrency(currencyCodeOrNull);
    return currency ? currency.code : null;
};

const initialCurrencyCode = resolveCode(
    cookieUtil.readCookie('preferred_currency')
);

const defaultState = {
    preferredCurrency: resolveCurrency(initialCurrencyCode),
    isCurrencyChosenByUser:
        initData.memberCountry !== 'Sverige' &&
        !!cookieUtil.readCookie('currency_selected_by_user'),
    desktopOpenId: null,
    mobileOpen: false
};

const yearInMilliseconds = 1000 * 60 * 60 * 24 * 365;

const createPreferredCurrencyCookie = currencyCode => {
    cookieUtil.createCookie(
        'preferred_currency',
        currencyCode,
        new Date(new Date().getTime() + yearInMilliseconds)
    );
};

export default (state = defaultState, action) => {
    const setPreferredCurrency = () => {
        createPreferredCurrencyCookie(action.currencyCode);
        return {
            ...state,
            preferredCurrency: resolveCurrency(action.currencyCode)
        };
    };

    const setCurrencyIfNotChosen = () => {
        if (cookieUtil.readCookie('preferred_currency')) {
            return state;
        }
        createPreferredCurrencyCookie(action.currencyCode);
        return {
            ...state,
            preferredCurrency: resolveCurrency(action.currencyCode)
        };
    };

    const setCurrencySelectedByUser = () => {
        cookieUtil.createCookie(
            'currency_selected_by_user',
            1,
            new Date(new Date().getTime() + yearInMilliseconds)
        );
        return {
            ...state,
            isCurrencyChosenByUser: true
        };
    };

    const openMultiCurrencySelectorDesktop = () => {
        const { id } = action;
        return {
            ...state,
            desktopOpenId: id
        };
    };

    const closeMultiCurrencySelectorDesktop = () => ({
        ...state,
        desktopOpenId: null
    });

    const openMultiCurrencySelectorMobile = () => ({
        ...state,
        mobileOpen: true
    });

    const closeMultiCurrencySelectorMobile = () => ({
        ...state,
        mobileOpen: false
    });

    const def = () => state;

    const reducers = {
        [actions.actionTypes.SET_PREFERRED_CURRENCY]: setPreferredCurrency,
        [actions.actionTypes
            .OPEN_MULTI_CURRENCY_DESKTOP]: openMultiCurrencySelectorDesktop,
        [actions.actionTypes
            .CLOSE_MULTI_CURRENCY_DESKTOP]: closeMultiCurrencySelectorDesktop,
        [actions.actionTypes
            .OPEN_MULTI_CURRENCY_MOBILE]: openMultiCurrencySelectorMobile,
        [actions.actionTypes
            .CLOSE_MULTI_CURRENCY_MOBILE]: closeMultiCurrencySelectorMobile,
        [actions.actionTypes
            .SET_CURRENCY_SELECTED_BY_USER]: setCurrencySelectedByUser,
        [actions.actionTypes.SET_CURRENCY_IF_NOT_CHOSEN]: setCurrencyIfNotChosen
    };

    return !isMultiCurrencyEnabled() ||
        !action ||
        !action.type ||
        !reducers[action.type]
        ? def()
        : reducers[action.type]();
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/reducers/multi-currency.js